import { render } from "./projectViewer.vue?vue&type=template&id=e0ff4dec&scoped=true"
import script from "./projectViewer.vue?vue&type=script&lang=js"
export * from "./projectViewer.vue?vue&type=script&lang=js"

import "./projectViewer.vue?vue&type=style&index=0&id=e0ff4dec&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ff4dec"]])

export default __exports__